import './UploadTagSheetHeaderTitle.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

const [block, element] = bem('upload-tag-sheet-header-title');

type UploadTagSheetHeaderTitleProps = {
  title: string;
  vendorName?: string;
};

const UploadTagSheetHeaderTitle = ({ title, vendorName }: UploadTagSheetHeaderTitleProps): React.JSX.Element => {
  return (
    <span className={block()}>
      <span>{title}</span>
      {vendorName && <span className={element('vendor')}>Vendor: {vendorName}</span>}
    </span>
  );
};

export default UploadTagSheetHeaderTitle;
